/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Timecode_Format_SmpteInputs */



/**
* | output |
* | --- |
* | "SMPTE (hh:mm:ss:ff)" |
*
* @param {Transcript_Export_Timecode_Format_SmpteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_timecode_format_smpte = /** @type {((inputs?: Transcript_Export_Timecode_Format_SmpteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Timecode_Format_SmpteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("SMPTE (hh:mm:ss:ff)")
	if (locale === "de") return /** @type {LocalizedString} */ ("SMPTE (hh:mm:ss:ff)")
	if (locale === "it") return /** @type {LocalizedString} */ ("SMPTE (hh:mm:ss:ff)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("SMPTE (чч:мм:сс:фф)")
	if (locale === "es") return /** @type {LocalizedString} */ ("SMPTE (hh:mm:ss:ff)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("SMPTE（hh:mm:ss:ff）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("SMPTE (時:分:秒:早送り)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एसएमपीटीई (hh:mm:ss:ff)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("SMPTE (hh:mm:ss:ff)")
	return /** @type {LocalizedString} */ ("SMPTE (hh:mm:ss:ff)")
});